module.exports = __webpack_public_path__ + "img/3.65864ebc.png";